import { styles } from './template.scss';
import { styles as textHelpersStyles } from '../../assets/text-helpers.scss';
import { renderErrorStateIcon } from '../../utils/widgets.utils';

export const templateInventory = document.createElement('template');

templateInventory.innerHTML = `
  <style>${textHelpersStyles}</style>
  <style>${styles}</style>
  <div class="wrapper widget-full-width">
    <h2 class="title display-2 widget-title">
        <span id="inventoryTitle"></span>
        ${renderErrorStateIcon()}
    </h2>

    <div class="content">
    <div class="inventory" id="inventory">
        <div class="inventory-block">
            <div gz-inventory="winWorkstations" class="item">
                <div class="item-content">
                    <span id="winWorkstationsIconName" gz-inventory-field="categoryName" class="item--title">
                        <span id="winWorkstationsIcon" class="item--icon">
                          <gz-tooltip id="winWorkstationsIconTooltip">
                            <span class="icon ds-icon-win_workstations"></span>
                          </gz-tooltip>
                        </span>
                    </span>
                    <span gz-inventory-field="value" class="item--value"></span>
                    <span gz-inventory-field="delta" class="item--delta"></span>
                </div>
                <span id="winWorkstationsName" class="item-name"></span>
            </div>
            <div gz-inventory="winServers" class="item">
                <div class="item-content">
                    <span id="winServersIconName" gz-inventory-field="categoryName" class="item--title">
                        <span id="winServersIcon" class="item--icon">
                            <gz-tooltip id="winServersIconTooltip">
                              <span class="icon ds-icon-win_servers"></span>
                            </gz-tooltip>
                        </span>
                    </span>
                    <span gz-inventory-field="value" class="item--value"></span>
                    <span gz-inventory-field="delta" class="item--delta"></span>
                </div>
                <span id="winServersName" class="item-name"></span>
            </div>
            <div gz-inventory="macOS" class="item">
                <div class="item-content">
                    <span id="macOSIconName" gz-inventory-field="categoryName" class="item--title">
                        <span id="macOSIcon" class="item--icon">
                            <gz-tooltip id="macOSIconTooltip">
                               <span class="icon icon-apple"></span>
                             </gz-tooltip>
                        </span>
                    </span>
                    <span gz-inventory-field="value" class="item--value"></span>
                    <span gz-inventory-field="delta" class="item--delta"></span>
                </div>
                <span id="macOSName" class="item-name"></span>
            </div>
            <div gz-inventory="linux" class="item">
                <div class="item-content">
                    <span id="linuxIconName" gz-inventory-field="categoryName" class="item--title">
                        <span id="linuxIcon" class="item--icon">
                          <gz-tooltip id="linuxIconTooltip">
                            <span class="icon icon-linux"></span>
                          </gz-tooltip>
                        </span>
                    </span>
                    <span gz-inventory-field="value" class="item--value"></span>
                    <span gz-inventory-field="delta" class="item--delta"></span>
                </div>
                <span id="linuxName" class="item-name"></span>
            </div>
            <span class="divider"></span>
            <div gz-inventory="physicalEndpoints" class="item">
                <div class="item-content">
                    <span id="physicalEndpointsIconName" gz-inventory-field="categoryName" class="item--title">
                        <span id="physicalEndpointsIcon" class="item--icon">
                            <gz-tooltip id="physicalEndpointsIconTooltip">
                                <span class="icon ds-icon-entity_endpoint"></span>
                            </gz-tooltip>
                        </span>
                    </span>
                    <span gz-inventory-field="value" class="item--value"></span>
                    <span gz-inventory-field="delta" class="item--delta"></span>
                </div>
                <span id="physicalEndpointsName" class="item-name"></span>
            </div>
            <div gz-inventory="virtualMachines" class="item">
                <div class="item-content">
                    <span id="virtualMachinesIconName" gz-inventory-field="categoryName" class="item--title">
                        <span id="virtualMachinesIcon" class="item--icon">
                            <gz-tooltip id="virtualMachinesIconTooltip">
                                <span class="icon ds-icon-virtual_machines"></span>
                            </gz-tooltip>
                        </span>
                    </span>
                    <span gz-inventory-field="value" class="item--value"></span>
                    <span gz-inventory-field="delta" class="item--delta"></span>
                </div>
                <span id="virtualMachinesName" class="item-name"></span>
            </div>
            <div gz-inventory="containers" class="item">
                <div class="item-content">
                    <span id="containersIconName" gz-inventory-field="categoryName" class="item--title">
                        <span id="containersIcon" class="item--icon">
                            <gz-tooltip id="containersIconTooltip">
                                <span class="icon icon-container"></span>
                           </gz-tooltip>
                        </span>
                    </span>
                    <span gz-inventory-field="value" class="item--value"></span>
                    <span gz-inventory-field="delta" class="item--delta"></span>
                </div>
                <span id="containersName" class="item-name"></span>
            </div>
            <span class="divider" id="dividerBeforeContainerHosts"></span>
            <div gz-inventory="containerHosts" class="item">
                <div class="item-content">
                    <span id="containerHostsIconName" gz-inventory-field="categoryName" class="item--title">
                        <span id="containerHostsIcon" class="item--icon">
                          <gz-tooltip id="containerHostsIconTooltip">
                              <span class="icon icon-container_hosts"></span>
                          </gz-tooltip>
                        </span>
                    </span>
                    <span gz-inventory-field="value" class="item--value"></span>
                    <span gz-inventory-field="delta" class="item--delta"></span>
                </div>
                <span id="containerHostsName" class="item-name"></span>
            </div>
          <gz-loader class="widget-loading" rows="1"></gz-loader>
        </div>

    </div>
  </div>
  </div>
`;
